module.exports = __webpack_public_path__ + "d80d152e3292f4d63f2e292fd7ab9c48.png";